import { useSmartTagsService } from 'nekst-api';

export interface RoadmapPreviewResponse {
  taskName: string;
  description: string;
}

export function useRoadmapPreviewService() {
  const smartTagsService = useSmartTagsService();

  const getRoadmapPreview = async (
    projectId: number,
    taskName: string,
    roadmapDescription: string | null | undefined,
    taskDescription: string | null | undefined
  ): Promise<RoadmapPreviewResponse> => {
    const textToPreview = roadmapDescription || taskDescription || '';

    if (!textToPreview || !projectId) {
      return {
        taskName: taskName || '',
        description: textToPreview,
      };
    }

    const result = await smartTagsService.previewSmartTags(
      projectId,
      textToPreview
    );

    return {
      taskName: taskName || '',
      description: result.text,
    };
  };

  return {
    getRoadmapPreview,
  };
}
